<section>
  <!-- Navbar & Hero Start -->
  <div class="container-xxl position-relative p-0 bg-white">
    <nav class="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
        <a href="" class="navbar-brand p-0">
            <!-- <h1 class="m-0"><i class="fa fa-search me-2"></i>SEO<span class="fs-5">Master</span></h1> -->
            <img src="assets/dataxplode-logo-1.png" alt="Logo">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span class="fa fa-bars"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <div class="navbar-nav ms-auto py-0">
                <a href="index.html" class="nav-item nav-link ">Home</a>
                <a (click)="AboutUsPage()" class="nav-item nav-link">About Us</a>
            </div>

        </div>
    </nav>
</div>

  
  
  <div class="fluid-container py-5 w-100 p-3">
   
    <!-- Spinner Start -->
    <div id="spinner"
    [ngClass]="{'show': spinnerVisible, 'hide': !spinnerVisible}" class="bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
      <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem" role="status">
        <!-- <span class="sr-only">Loading...</span> -->
      </div>
    </div>
    <!-- Spinner End -->

    

    <!-- Start -->
    <header class="text-center mb-5 text-white">
      <div class="row">
        <div class="col-md-7 mx-auto">
          <h1>Choose the Perfect Plan for You</h1>
          <p>
            Select from our flexible pricing options to find the plan that fits
            your needs. Each plan is designed to offer you the best value and
            features for your goals.
          </p>
        </div>
      </div>
    </header>
    <!-- END -->

    <div class="row text-center align-items-end">
      <!-- Pricing Table -->
      <div *ngFor="let plan of planArray" class="col-md-3 col-sm-6 mb-5 mb-md-0">
        <div (click)="setSelectdPlan(plan.name)" [ngClass]="currentSelectedPlan == plan.name ? 'bg-white box' :'bg-white'" class="p-5 rounded-md  transition-all duration-700">
          <i *ngIf="currentSelectedPlan == plan.name" class="fa fa-check-circle fade-in transition-all duration-1000" style="font-size:24px;color:#0d6efd"></i>
          <h1 class="h6 text-uppercase font-weight-bold mb-4">{{plan.name}}</h1>
          <h2 class="h1 font-weight-bold">
            ${{plan.price}}<span class="text-small font-weight-normal ml-2">/ <br />{{plan.billingCycle}}</span>
          </h2>

          <div class="custom-separator my-4 mx-auto bg-primary"></div>

          <ul class="list-unstyled my-5 text-small text-left">
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>product Search
              <br />
              <p *ngIf="plan.name=='free'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='basic'">(upto 100 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 200 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 500 searches/month)</p>
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Keyword Search<br />  
              <p *ngIf="plan.name=='free'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='basic'">(upto 100 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 200 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 500 searches/month)</p>
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Review Analysis
              <br />
              <p *ngIf="plan.name=='free'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='basic'">(upto 100 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 200 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 500 searches/month)</p>
              
            </li>
            <li class="mb-3 text-muted">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">Porter Strategy analysis</del>
              <span *ngIf="plan.name=='basic'">Porter Strateg analysis</span>
              <span *ngIf="plan.name=='pro'">Porter Strategy analysis</span>
              <span *ngIf="plan.name=='enterprise'">Porter Strategy analysis</span>
              <p *ngIf="plan.name=='basic'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 10 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 30 searches/month)</p>
            </li>

            <li class="mb-3 ">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">SWOT Analysis</del>
              <span *ngIf="plan.name=='basic'">SWOT Analysis</span>
              <span *ngIf="plan.name=='pro'">SWOT Analysis</span>
              <span *ngIf="plan.name=='enterprise'">SWOT Analysis</span>
              <p *ngIf="plan.name=='basic'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 10 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 30 searches/month)</p>
            </li>

            <li class="mb-3 ">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">BCG Matrix</del>
              <span *ngIf="plan.name=='basic'">BCG Matrix</span>
              <span *ngIf="plan.name=='pro'">BCG Matrix</span>
              <span *ngIf="plan.name=='enterprise'">BCG Matrix</span>
              <p *ngIf="plan.name=='basic'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 10 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 30 searches/month)</p>
            </li>

            <li class="mb-3 ">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">product Feature Matrix</del>
              <span *ngIf="plan.name=='basic'">product Feature Matrix</span>
              <span *ngIf="plan.name=='pro'">product Feature Matrix</span>
              <span *ngIf="plan.name=='enterprise'">product Feature Matrix</span>
              <p *ngIf="plan.name=='basic'">(upto 5 searches/month)</p>
              <p *ngIf="plan.name=='pro'">(upto 10 searches/month)</p>
              <p *ngIf="plan.name=='enterprise'">(upto 30 searches/month)</p>
            </li>
    
            <li class="mb-3 ">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">Data Export</del>
              <span *ngIf="plan.name=='basic'">Data Export</span>
              <span *ngIf="plan.name=='pro'">Data Export</span>
              <span *ngIf="plan.name=='enterprise'">Data Export</span>
              <p *ngIf="plan.name=='basic'">(CSV Format only)</p>
              <p *ngIf="plan.name=='pro'">(CSV & Excel Format only)</p>
              <p *ngIf="plan.name=='enterprise'">(CSV, Excel & Json only)</p>
            </li>

            <li class="mb-3 ">
              <i [ngClass]="plan.name=='free'?'fa fa-times':'fa fa-check text-primary'" class=" mr-2"></i>
              <del *ngIf="plan.name == 'free'">Priority Support</del>
              <span *ngIf="plan.name=='basic'">Priority Support</span>
              <span *ngIf="plan.name=='pro'">Priority Support</span>
              <span *ngIf="plan.name=='enterprise'">Priority Support</span>
              <p *ngIf="plan.name=='basic'">(Chat Support)</p>
              <p *ngIf="plan.name=='pro'">(Email & Chat Support)</p>
              <p *ngIf="plan.name=='enterprise'">(Phone, Email, & Chat Support)</p>
            </li>

          </ul>
          <a (click)="getselectedPlan(plan)"  *ngIf="currentSelectedPlan == plan.name"  [ngClass]="currentSelectedPlan == plan.name ? 'btn-primary' :'btn-primary'" class="btn btn-block fade-in p-3 w-50 shadow rounded-pill">
                <span *ngIf="currentSelectedPlan == plan.name">Next</span>
          </a>
        </div>
      </div>
      <!-- END -->

      <!-- Pricing Table2 (Duplicate of the second one) -->
      <!-- <div class="col-md-3 col-sm-6 mb-5 mb-md-0">
        <div class="bg-white p-5 rounded-md shadow">
          <h1 class="h6 text-uppercase font-weight-bold mb-4">Basic</h1>
          <h2 class="h1 font-weight-bold">
            $149<span class="text-small font-weight-normal ml-2">/ Quarterly</span>
          </h2>

          <div class="custom-separator my-4 mx-auto bg-primary"></div>

          <ul class="list-unstyled my-5 text-small text-left">
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>product Search
              <br /><a> </a>(upto 100 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Keyword Search<br /><a>
              </a>(upto 100 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Review Analysis
              <br /><a> </a>(upto 100 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>Porter Strategy
              analysis <br /><a> </a>(upto 5 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> 
              SWOT Analysis<br /><a>
              </a>(upto 5 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> BCG Matrix<br /><a>
              </a>(upto 5 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> product Feature
              Matrix<br /><a> </a>(upto 5 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Data Export<br /><a>
              </a>(CSV Format only)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Priority Support<br /><a>
              </a>(Chat Support)
            </li>
          </ul>
          <a  (click)="setSelectdPlan('Basic')" [ngClass]="currentSelectedPlan =='Basic' ? 'btn-success' :'btn-primary'"  class="btn  btn-block p-2 shadow rounded-pill">Subscribe</a>
        </div>
      </div> -->
      <!-- END -->

      <!-- Pricing Table3 (Duplicate of the second one) -->
      <!-- <div class="col-md-3 col-sm-6 mb-5 mb-md-0">
        <div class="bg-white p-5 rounded-md shadow">
          <h1 class="h6 text-uppercase font-weight-bold mb-4">pRO</h1>
          <h2 class="h1 font-weight-bold">
            $249<span class="text-small font-weight-normal ml-2">/<br />
              Half-Yearly</span>
          </h2>

          <div class="custom-separator my-4 mx-auto bg-primary"></div>

          <ul class="list-unstyled my-5 text-small text-left">
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>product Search
              <br /><a> </a>(upto 200 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Keyword Search<br /><a>
              </a>(upto 200 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Review Analysis
              <br /><a> </a>(upto 200 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>Porter Strategy
              analysis <br /><a> </a>(upto 10 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> SWOT Analysis<br /><a>
              </a>(upto 10 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> BCG Matrix<br /><a>
              </a>(upto 10 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> product Feature
              Matrix<br /><a> </a>(upto 10 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Data Export<br /><a>
              </a>(CSV & Excel Format only)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Priority Support<br /><a>
              </a>(Email & Chat Support)
            </li>
          </ul>
          <a (click)="setSelectdPlan('pro')" [ngClass]="currentSelectedPlan =='pro' ? 'btn-success' :'btn-primary'"  class="btn  btn-block p-2 shadow rounded-pill">Subscribe</a>
        </div>
      </div> -->
      <!-- END -->

      <!-- Pricing Table4 (Duplicate of the second one) -->
      <!-- <div class="col-md-3 col-sm-6 mb-5 mb-md-0">
        <div class="bg-white p-5 rounded-md shadow"P
          <h1 class="h6 text-uppercase font-weight-bold mb-4">eNTERPRISE</h1>
          <h2 class="h1 font-weight-bold">
            $699<span class="text-small font-weight-normal ml-2">/ <br />Yearly</span>
          </h2>

          <div class="custom-separator my-4 mx-auto bg-primary"></div>

          <ul class="list-unstyled my-5 text-small text-left">
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>product Search
              <br /><a> </a>(upto 500 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Keyword Search<br /><a>
              </a>(upto 500 searches/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Review Analysis
              <br /><a> </a>(upto 500 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i>Porter Strategy
              analysis <br /><a> </a>(upto 30 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> SWOT Analysis<br /><a>
              </a>(upto 30 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> BCG Matrix<br /><a>
              </a>(upto 30 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> product Feature
              Matrix<br /><a> </a>(upto 30 Analysis/month)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Add-On:<br /><a> </a>(Custom Features)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Data Export<br /><a>
              </a>(CSV, Excel & Json only)
            </li>
            <li class="mb-3">
              <i class="fa fa-check mr-2 text-primary"></i> Priority Support<br /><a>
              </a>(Phone, Email, & Chat Support)
            </li>
          </ulP
          <a  (click)="setSelectdPlan('enterprise')" [ngClass]="currentSelectedPlan =='enterprise' ? 'btn-success' :'btn-primary'"  class="btn  btn-block p-2 shadow rounded-pill">Subscribe</a>
        </div>
      </div> -->
      <!-- END -->
    </div>
  </div>

  <footer class="footer bg-primary">
    <p>
      © 2024 DataXplode. All rights reserved. | <a>Privacy Policy</a> |
      <a>Terms of Service</a>
    </p>
  </footer>
</section>